import { Box,Button,Flex,Select,InputGroup,
  InputLeftElement,Input, Heading, Text, 
  TableContainer,FormControl,Table,Thead,Tbody,Th,Tr,Td } from "@chakra-ui/react";
import { DateFilter, TopDisplay} from "../../../components";
import { LuSearch as SearchIcon } from "react-icons/lu";
import { useState ,useEffect} from "react";
import styled from "@emotion/styled";
import { useMutation, useQuery, useQueryClient } from 'react-query';
import apiCall from '../../../utils/apiCall';
import { BsDownload as DownloadIcon } from "react-icons/bs";
import { downloadApi } from "../../../api";
import {useAtom,atom} from 'jotai'
import { openAtom, notificationAtom, openNAtom , modalAtom } from "../../../context";
import { TbReload as ReloadIcon } from "react-icons/tb";
import ReactPaginate from 'react-paginate';
import { MdMoreVert as MoreIcon } from "react-icons/md";
import { FaRegFileAlt as FileIcon } from "react-icons/fa";
import { format } from "date-fns";
import ReactSelect from "../../../components/Select";
import { Formik,Form,Field } from "formik";
import { NewLoader as Loader } from "../../../customs";

import {
  Grid,
  GridItem,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverHeader,
  PopoverBody,
  PopoverFooter,
  PopoverArrow,
  PopoverCloseButton,
  PopoverAnchor,
} from '@chakra-ui/react'
import appStore, { activePeriod } from "../../../store";

const indexAtom = atom<number | null>(null);
const list = [
  {
    StudentId:Math.floor(Math.random() * 10000)+1,
    FirstName:'Abey',
    LastName:'Adesola',
    OldEmail:'Abey.Adesola@gmail.com',
    NewEmail:"Osakpolo@gmail.com",
    Reason:"Not working",
    DateRequested:"01-03-2024",
    Status:"Pending",
  },
  {
    StudentId:Math.floor(Math.random() * 10000)+1,
    FirstName:'Abey',
    LastName:'Adesola',
    OldEmail:'Abey.Adesola@gmail.com',
    NewEmail:"Osakpolo@gmail.com",
    Reason:"Not working",
    DateRequested:"01-03-2024",
    Status:"Pending",
  },
  {
    StudentId:Math.floor(Math.random() * 10000)+1,
    FirstName:'Abey',
    LastName:'Adesola',
    OldEmail:'Abey.Adesola@gmail.com',
    NewEmail:"Osakpolo@gmail.com",
    Reason:"Not working",
    DateRequested:"01-03-2024",
    Status:"Pending",
  },
  {
    StudentId:Math.floor(Math.random() * 10000)+1,
    FirstName:'Abey',
    LastName:'Adesola',
    OldEmail:'Abey.Adesola@gmail.com',
    NewEmail:"Osakpolo@gmail.com",
    Reason:"Not working",
    DateRequested:"01-03-2024",
    Status:"Pending",
  },
  {
    StudentId:Math.floor(Math.random() * 10000)+1,
    FirstName:'Abey',
    LastName:'Adesola',
    OldEmail:'Abey.Adesola@gmail.com',
    NewEmail:"Osakpolo@gmail.com",
    Reason:"Not working",
    DateRequested:"01-03-2024",
    Status:"Pending",
  },
]

const HeadStyle={
  borderBottom:"1px solid var(--dark-green-color)",
  padding:'15px 5px',
}
const DataStyle = {
  padding:'5px 5px',
  thcolor:'var(--dark-green-color)'
}


const ROWSTYLE = styled.tr`
  & > td:last-of-type{
    width:50px;
    height:63px;
    & > div{
      display:none;
    }
  }
  &:hover > *{
    cursor: pointer;
    background-color:var(--table-highlight);
  } 
  & > td{
    width:140px;
  }
  &:hover > td:last-of-type{
    
    & > div{
      display: block;
    }
  }
  & > td > div.active{
    display: block;
  }
`

export default function StudentScoreReport({ data }:any)  {
const [hide,set_hide] = useState<boolean>(true);
const queryClient = useQueryClient();
const [activeIndex] = useAtom(indexAtom);
const [,set_open] = useAtom(openAtom);
const [,set_Nopen] = useAtom(openNAtom);
const [,set_notification]= useAtom(notificationAtom);
const aPeriod = appStore.get(activePeriod)?.Id;
const [selected_examperiod,set_selected_examperiod] = useState<string>('');
 const [selected_subject,set_selected_subject] = useState<null | string>(null);
 const [selected_level,set_selected_level] = useState<null | string>(null);
 const [selected_examsubject,set_selected_examsubject] = useState<null | string>(null);

 
const {data:allExamPeriod} = useQuery(['exam-period'],{
      queryFn:async ()=> await apiCall().get(`exam/setup/examPeriod`),
      select(data){
       
        return data.data.Data;
      },
    });
  
    const {data:allExamSubject} = useQuery(['exam-subject'],{
      queryFn:async ()=> await apiCall().get(`exam/setup/examSubject`),
      select(data){
        return data.data.Data;
      },
    })

    const {data:allLevel} = useQuery(['exam-level'],{
      queryFn:async ()=> await apiCall().get(`setup/GetAllExemption`),
      select(data){
        return data.data.Data;
      },
    })

  const {data:allstudentScore, isLoading} = useQuery<any>(['Student-score'+selected_examperiod+selected_level],{
      queryFn:async()=>await apiCall().get(`Exam/GetAllStudentScore?ExamPeriodId=${selected_examperiod}&SubjectId=${selected_subject ||''}&LevelId=${selected_level || ''}`,{
        }),
      enabled:Boolean(selected_examperiod || selected_subject || selected_level),
      select(data){
      return data.data.reportItems;
      }
    });

  const [search,set_search] = useState('');

  const [filter_data,set_filter_data] = useState<any>(allstudentScore)

  useEffect(() => {
    if (search && allstudentScore && allstudentScore
      ?.length > 0
    ) {
      handleSearch({ target: { value: search } });
    } 
    if(selected_examperiod && search && allstudentScore && allstudentScore?.length > 0){
      if(Array.isArray(allstudentScore)){
        let p:any = allExamPeriod.find((e:any) => e?.Id == selected_examperiod)
        const periodFilteredData = allstudentScore.filter((eData: any) => eData?.ExamPeriod === p.ExamName);
        const new_data = periodFilteredData?.filter((eData: any) => {
          const studentNoMatches = eData.StudentNo?.toString().toLowerCase().includes(search.toLowerCase());
          const nameMatches = (eData.FirstName + " " + eData.LastName)?.toLowerCase().includes(search.toLowerCase());

          return studentNoMatches || nameMatches;
        });

        set_filter_data(new_data.length > 0 ? new_data : []);
      }      
    }
    else {
      set_filter_data(allstudentScore);
    }
  }, [allstudentScore, search, selected_examperiod]);  
  

  const handleSearch = (e: any) => {
    let val = e.target.value;
    set_search(val);  
  
    if (val && Array.isArray(allstudentScore)) {
      let new_data = allstudentScore.filter((eData: any) => {
        const studentNoMatches = eData.StudentNo?.toString().toLowerCase().includes(val.toLowerCase());
        const nameMatches = (eData.FirstName + " " + eData.LastName)?.toLowerCase().includes(val.toLowerCase());
  
        return studentNoMatches || nameMatches;
      });
  
      if (new_data.length > 0) {
        set_filter_data(new_data);
      } else {
        set_filter_data([]);  
      }
    } else {
      // Clear table when search is cleared
      set_filter_data([]);
    }
  };
  
  const itemsPerPage = 100;
  const [itemOffset, setItemOffset] = useState(0);
  const endOffset = itemOffset + itemsPerPage;
  const currentItems = filter_data?.slice(itemOffset, endOffset);
  const pageCount = Math.ceil(filter_data?.length / itemsPerPage);
  
  const handlePageClick = (event: any) => {
    const newOffset = (event.selected * itemsPerPage) % filter_data?.length;
    setItemOffset(newOffset);
  };


  const handleFilter = (e:string,type:string) =>{
    const value = e || '';
    if(value){
      let data = [];
      if(type === 'level'){
        data = allstudentScore?.filter((eData:any) => {
          return eData.Level === value}
        );
        set_selected_level(value);
      }
      else if(type === 'period'){
        data = allstudentScore?.filter((eData:any) => {
          return eData.ExamPeriod === value});
        set_selected_examperiod(value);
      }
      set_filter_data(data)
    }
    else{
      set_filter_data(allstudentScore) 
    }

  } 

  const handleFilter2=(str:string) =>{
    if(str){
      set_selected_examsubject(str);
      let check:any = allstudentScore.filter((e:any) => e.Subject == str);
      if(check && check?.length > 0){
        set_filter_data(check)
      }
    }
  }

  const handleFilter3 = (e: any, type: string) => {
    const value = type === 'level' ? Number(e || 0) : e;
  
    if (type === 'level') {
      if (value || !isNaN(value)) {
        let data = allstudentScore?.filter((eData: any) => {
          return eData.Level?.Id == value;
        });
  
        if (selected_examperiod) {
          data = data?.filter((eData: any) => eData.ExamPeriod == selected_examperiod);
        }
  
        set_filter_data(data && data.length > 0 ? data : allstudentScore);
        set_selected_level(value);
      }
    } else if (type === 'period') {
      if (value) {
        set_selected_examperiod(value); 
        let check: any = allstudentScore.filter((e: any) => e.ExamPeriod == value);
        set_filter_data(check && check?.length > 0 ? check : allstudentScore);
      }
    } else {
      
      let filteredData = allstudentScore;
  
      if (selected_examperiod) {
        filteredData = filteredData.filter(
          (e: any) => e.ExamPeriod == selected_examperiod
        );
      }
  
      set_filter_data(filteredData);
    }
  };

  const handleChangePeriod = (value: any) => {
    if (value) {
      set_selected_examperiod(value?.Id.toString());
  
      if (Array.isArray(allstudentScore)) {
        const periodFilteredData = allstudentScore.filter((eData: any) => eData.ExamPeriod === value.ExamName);
  
        if (search) {
          //console.log(search,'search')
          const new_data = periodFilteredData?.filter((eData: any) => {
            const studentNoMatches = eData.StudentNo?.toString().toLowerCase().includes(search.toLowerCase());
            const nameMatches = (eData.FirstName + " " + eData.LastName)?.toLowerCase().includes(search.toLowerCase());
  
            return studentNoMatches || nameMatches;
          });
  
          set_filter_data(new_data.length > 0 ? new_data : []);
        } else {
          //console.log('skip search ressult')
          set_filter_data([periodFilteredData]);  // If no search input, clear data for the selected period
        }
      }
    }
  };
  
  


  // const { mutate: handleDownload, isLoading: isDownloading } = useMutation({
  //   mutationKey: ['download-student-score-report'],
  //   mutationFn: async () => {
  //     // Assign values with fallback for null cases
  //     const levelId = allLevel.find((eLevel: { Name: string |''; }) => eLevel.Name === selected_level)?.Id || 'Name';
  //     const examPeriodId = selected_examperiod || '';
  //     const examSubjectId = selected_subject || 'Name';
  
  //     // Log values for verification
  //     console.log("ExamPeriodId:", examPeriodId);
  //     console.log("ExamSubjectId:", examSubjectId);
  //     console.log("LevelId:", levelId);
  
  //     // Proceed with non-empty filter values
  //     const params = new URLSearchParams();
  //     if (selected_examperiod) params.append("ExamPeriodId", selected_examperiod);
  //     if (selected_level) params.append("LevelId", selected_level);
  //     if (selected_subject) params.append("ExamSubjectId", selected_subject);
  
  //     const url = `/ExamReport/downloadStudentScoreReport?${params.toString()}`;
  //     const method = "POST";
  //     const body = {};
  //     const config = {};
  //     const download = true;
  
  //     return await downloadApi(url, method, body, config, download);
  //   },
  //   onSuccess: async (data) => {
  //     const file = data;
  //     if (file) {
  //       const url = window.URL.createObjectURL(file);
  //       const link = document.createElement("a");
  //       link.href = url;
  //       link.setAttribute("download", "Student Score-report.xlsx");
  //       document.body.appendChild(link);
  //       link.click();
  //       document.body.removeChild(link);
  
  //       set_notification({
  //         type: 'success',
  //         message: data?.data?.Message || 'Student Score Report downloaded successfully'
  //       });
  //       set_Nopen(true);
  //     } else {
  //       set_notification({
  //         type: 'error',
  //         message: 'Oops! An error occurred while trying to download the file'
  //       });
  //       set_Nopen(true);
  //     }
  //   },
  //   onError(error:any, variables, context) {
  //     set_notification({
  //       type:'error',
  //       message:error?.data?.Message || 'Error Occured'
  //     })
  //     set_Nopen(true);
  //   },
  //   onSettled: () => {
  //     set_open(false);
  //   }
  // });
  
  const { mutate: handleDownload, isLoading: isDownloading } = useMutation({
    mutationKey: [selected_examperiod, selected_subject, selected_level],
    mutationFn: async () => {
      let url = `/ExamReport/downloadStudentScoreReport`;
  
      const params = new URLSearchParams();
      if (selected_examperiod) params.append("ExamPeriodId", selected_examperiod);
      if (selected_level) params.append("LevelId", selected_level);
      if (selected_subject) params.append("ExamSubjectId", selected_subject);
  
      // If any parameters were added, append them to the URL
      if (params.toString()) {
        url += `?${params.toString()}`;
      }
  
      const method = "POST", body = {}, config = {}, download = true;
      return await downloadApi(url, method, body, config, download);
    },
    onSuccess: async (data: any) => {
      // Initialize the download
      //console.log(data, 'download data');
      const file = data;
  
      if (file) {
        const url = window.URL.createObjectURL(file);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "Candidate Registration-report.xlsx");
        document.body.appendChild(link);
        link.click();
       // console.log(file, 'data');
        set_notification({
          type: 'success',
          message: data?.data?.Message || 'Registered Candidate Report downloaded successfully'
        });
        set_Nopen(true);
      } else {
        set_notification({
          type: 'error',
          message: 'Oops! An error occurred while trying to download the file'
        });
        set_Nopen(true);
      }
    },
    onError(error: any) {
      set_notification({ 
        type: 'error',
        message: error?.data?.Message || 'An error occurred'
      });
      set_Nopen(true);
    },
    onSettled: () => {
      set_open(false);
    }
  });
  

    return (
      <>
        <Box>
          <TopDisplay label="Student Score Report" button_array={[
            <Button disabled={isDownloading} type="submit" color="var(--white-color)" 
              bg="var(--dark-green-color)" leftIcon={<DownloadIcon/>}  
              onClick={()=>handleDownload()}> 
              {isDownloading ? "Downloading" : 'Download Score Report'}
            </Button>,
          ]} />
    
          <Flex gap="20px" wrap="wrap" mt="20px">
            <InputGroup h="40px" width="250px" bg="var(--white-color)" borderColor="var(--dark-green-color)">
              <InputGroup>
                <InputLeftElement pointerEvents='none'>
                  <SearchIcon color='gray.300' />
                </InputLeftElement>
                <Input
                  value={search} 
                  onChange={handleSearch}
                  type='text' 
                  placeholder='StudentNo or Name'
                  bg="var(--white-color)" 
                  borderColor="var(dark-green-color)"
                />
                <span 
                  style={{
                    position: 'absolute',
                    zIndex: '1',
                    right: '10px',
                    cursor: 'pointer',
                    top: '12px',
                  }}
                  onClick={() => {
                    set_filter_data(allstudentScore);
                    set_search(""); 
                  }}>
                  <ReloadIcon />
                </span>
              </InputGroup>
            </InputGroup>
            <ReactSelect 
              name="ExamName"
              onChange={handleChangePeriod}
              placeholder="Exam Period"
              options={allExamPeriod?.map((e: any) => ({ ...e, ['label']: e.ExamName, ['value']: e.Id }))}
            />
              <Select placeholder="Level" width="140px" bg="var(--white-color)" 
              borderColor="var(dark-green-color)"onChange={(e:any)=>handleFilter3(e.target.value,'level')} >
                {allLevel && allLevel.length > 0 ?
                    allLevel.map((eType:any) => <option key={eType.Id} value={eType.Id}>{eType.Name}</option>)
                  :''}
            </Select>
            <Select placeholder='Exam Subject' width="140px" bg="var(--white-color)" 
              borderColor="var(dark-green-color)" onChange={(e:any)=>handleFilter2(e.target.value)}
                  name="ExamSubjectId"
                >
                  <>{allExamSubject && allExamSubject.length > 0 ?
                    allExamSubject.map((eType:any) => <option key={eType.Id} value={eType.Name}>{eType.Name}</option>)
                  :''}</>
                </Select>
          </Flex>
    
          <Flex mt="25px" flexDir="column" gap="10px">
            <Heading m="0" fontSize="1rem">All Exam Score Report</Heading>
            <Text m="0" fontSize=".8rem">Showing {itemOffset} - {itemOffset + itemsPerPage > filter_data?.length ? filter_data?.length : endOffset} of {filter_data?.length}</Text>
          </Flex>
    
          {filter_data && filter_data.length > 0 ? (
            <TableContainer mt="20px">
              <Table size='sm'>
                <Thead>
                  <Tr>
                    <Th>StudentNo</Th>
                    <Th>First Name</Th>
                    <Th>Last Name</Th>
                    <Th>Exam Period</Th>
                    <Th>Score</Th>
                    <Th>Cut-Off Mark</Th>
                    <Th>Grade</Th>
                    <Th>Subject</Th>
                    <Th>Exam Status</Th>
                    <Th w="50px"></Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {currentItems.map((eUpgradeScore: any, index: number) => (
                    <Tr key={eUpgradeScore.Id}>
                      <Td>{eUpgradeScore.StudentNo || 'N/a'}</Td>
                      <Td>{eUpgradeScore.FirstName || 'N/A'}</Td>
                      <Td>{eUpgradeScore.LastName || 'N/A'}</Td>
                      <Td>{eUpgradeScore.ExamPeriod || 'N/A'}</Td>
                      <Td>{typeof eUpgradeScore.Score == 'number' ? eUpgradeScore.Score : 'N/A'}</Td>
                      <Td>{typeof eUpgradeScore.CutOffMark === 'number' ? eUpgradeScore.CutOffMark : 'N/A'}</Td>
                      <Td>{eUpgradeScore.Grade || 'N/A'}</Td>
                      <Td>{eUpgradeScore.Subject || 'N/A'}</Td>
                      <Td>{eUpgradeScore.ExamStatus || 'N/A'}</Td>
                      <Td minW="60px" w="50px" h="50px">
                        <Option {...{ index, candidate: eUpgradeScore }} />
                      </Td>
                    </Tr>
                  ))}
                </Tbody>
              </Table>
            </TableContainer>
          ) : (
            search ? (
              <Box textAlign="center" color="red" mt={4}>
                Student not found
              </Box>
            ) : (
              <Text>No Score Report</Text>
            )
          )}
      <StylePaginateBox>
        <ReactPaginate
          breakLabel="..."
          nextLabel=">"
          onPageChange={handlePageClick}
          pageRangeDisplayed={5}
          pageCount={pageCount}
          previousLabel="<"
          renderOnZeroPageCount={null}
        />
      </StylePaginateBox>

    </Box>
    <Loader show={isLoading} />
</>
  )
}
const StylePaginateBox = styled.div`
  width:100%;
  & > ul{
    list-style-type: none;
    text-align:center;
    padding:0;
    margin:0;
    margin-top:10px;
  } 
  & > ul > li{
    display: inline;
    margin:0 5px;
    padding:2px 5px;
    border-radius: 3px;
    background-color: transparent;
    color:var(--dark-green-color);
  }
  & > ul > li.selected{
    background-color: var(--highlight-paginate-background);
    color:var(--highlight-paginate-color);
  }
  & > ul > li:first-of-type,
  & > ul > li:last-of-type{
    font-weight: bold;
  }
`

const sx={
  ':hover':{
    bg:'var(--content-background)'
  }
}
const Option = (props:any)=>{
  const index = props.index;
  const candidate= props.candidate;
  const [ind,set_index] = useAtom(indexAtom);
  const [,set_open] = useAtom(openAtom);
  const [,set_modal] = useAtom(modalAtom);
  const [,set_N_open] = useAtom(openNAtom);
  const [,set_notification] = useAtom(notificationAtom);

  const onClick=()=>{
    if(index === ind){
      set_index(null);
      return;
    }
    set_index(index);
  }

 
  const handleViewDetails = () =>{
    set_index(null);
    set_modal({
      header:'Candidate Details',
      content:<ViewDetails candidate={candidate} />
    })
    set_open(true);
  }
  
const ViewDetails = (props:any) =>{
  return(
  <Flex flexDir="column" minWidth="600px" gap="50px">
    <Flex align="center" gap="20px">
      <Flex gap="20px">
        <Text width="150px"  fontWeight="500" color="var(--light-text)">First Name</Text>
        <Text fontWeight="500">  {props.candidate.FirstName}</Text>
      </Flex>
    </Flex>
    <Grid templateColumns="1fr" templateRows="repeat(3,1fr)" gap="30px">
     
      <GridItem as={Flex} gap="20px">
        <Text width="150px"  fontWeight="500" color="var(--light-text)">LastName</Text>
        <Text fontWeight="500">{props.candidate.LastName || 'N/A'}</Text>
      </GridItem>
      <GridItem as={Flex} gap="20px">
        <Text width="150px"  fontWeight="500" color="var(--light-text)">ExamPeriod</Text>
        <Text fontWeight="500">{candidate?.ExamPeriod || 'N/A'}</Text>
      </GridItem>
      <GridItem as={Flex} gap="20px">
        <Text width="150px"  fontWeight="500" color="var(--light-text)">Score</Text>
        <Text fontWeight="500">
        {typeof candidate.Score == 'number'?candidate.Score:'N/A'}
        </Text>
      </GridItem >
       <GridItem as={Flex} gap="20px">
        <Text width="150px"  fontWeight="500" color="var(--light-text)">Cut-Off Mark</Text>
        <Flex fontWeight="500">
        {typeof candidate.CutOffMark === 'number'?candidate.CutOffMark:'N/A'}
        </Flex>
      </GridItem >
      <GridItem as={Flex} gap="20px">
        <Text width="150px"  fontWeight="500" color="var(--light-text)">Grade</Text>
        <Text fontWeight="500">{candidate?.Grade ||'N/A'}</Text>
      </GridItem >
      <GridItem as={Flex} gap="20px">
        <Text width="150px"  fontWeight="500" color="var(--light-text)">Subjects</Text>
        <Text fontWeight="500">{candidate?.Subject ||'N/A'}</Text>
        {/* <Text fontWeight="500">
        {candidate?.Subjects?.map((eSubject:any)=>eSubject.ExamSubject.Name)?.join(',')?.length > 35?candidate?.Subjects?.map((eSubject:any)=>eSubject.ExamSubject.Name)?.join(',').slice(0,31)+' ...':candidate?.Subjects?.map((eSubject:any)=>eSubject.ExamSubject.Name)?.join(',') ||'N/A'}
        </Text> */}
      </GridItem >
      <GridItem as={Flex} gap="20px">
        <Text width="150px" fontWeight="500" color="var(--light-text)">ExamStatus</Text>
        <Text fontWeight="500">{props.candidate.ExamStatus || 'N/A'}</Text>
      </GridItem>
    </Grid>
  </Flex>
  )}

useEffect(()=>{
  return ()=>set_index(null)
},[])
return(
  <Popover>
  <PopoverTrigger>
    <Button onClick={onClick} bg="var(--cipm-light-green)"><MoreIcon /></Button>
  </PopoverTrigger>
  <PopoverContent width="fit-content">
    <PopoverArrow />
    <PopoverBody>
      <Grid templateColumns="1fr" p="6px">
      <GridItem sx={sx} p="8px 4px" onClick={handleViewDetails}>View Details</GridItem>
      </Grid>
    </PopoverBody>
  </PopoverContent>
</Popover>
)
}